import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fuwuqi",
  "use": "icon-fuwuqi-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-fuwuqi\"><path d=\"M0 0\" p-id=\"8601\" /><path d=\"M128 608h768v192H128v-192z m0-256h768v192H128v-192z m32-140.8h704l28.8 73.6H131.2L160 211.2zM131.2 160L64 284.8V864h896V284.8L896 160H131.2z\" p-id=\"8602\" /><path d=\"M768 416h64v64h-64zM768 672h64v64h-64z\" p-id=\"8603\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol